module.exports = ({
    "CDMS930TT001": "ARM",
    "CDMS930H001": "สุ่ม",
    "CDMS930H002": "ปัจจัยของการแบ่งกลุ่ม (Stratification group)",
    "CDMS930H003": "ข้อมูลกลุ่ม (ARM)",
    "CDMS930H004": "ผู้แก้ไข",
    "CDMS930H005": "วันที่แก้ไข",
    "CDMS931TT001": "IP No.",
    "CDMS931H001": "ข้อมูลกลุ่ม (ARM)",
    "CDMS931H002": "IP No.",
    "CDMS931H003": "หมายเลขซีเรียล",
    "CDMS931H004": "ผู้แก้ไข",
    "CDMS931H005": "วันที่แก้ไข"
});
